import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, RichTextContent } from '@vibesites/runtime/react';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Privacy policy banner',
    },
  },
};


export function PrivacyPolicyHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="privacypolicyhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Privacy policy banner"
    >
      <RichTextContent
        path="privacypolicyhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableSlotGroup
        groupPath="privacypolicyhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PrivacyPolicyHero',
  displayName: 'Privacy Policy Hero',
  tokens: {
    'privacypolicyhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Privacy Policy</p>',
    },
  },
  slotGroups: {
    'privacypolicyhero.bg_image': bgImageDef,
  },
};

(PrivacyPolicyHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default PrivacyPolicyHero;
